import { regionID } from '@caresend/types';
import { getPythonRequestURL } from '@caresend/utils';
import { getAuth } from '@firebase/auth';
import { projectID } from '../helpers.js';

const getRequestHeaders = async () => {
    var _a;
    const auth = getAuth();
    const idToken = await ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken());
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Authorization', `Bearer ${idToken}`);
    return headers;
};
const pythonGCFCallable = (functionName) => async (...args) => {
    var _a;
    const request = {
        functionName,
        queryParams: args[0],
        regionID,
        projectID,
    };
    const url = getPythonRequestURL(request);
    const auth = getAuth();
    const idToken = await ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken());
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${idToken}`,
        },
    });
    const res = (await response.json());
    return res;
};
const pythonGCFPostCallable = (functionName) => async (payload) => {
    const request = {
        functionName,
        regionID,
        projectID,
    };
    const headers = await getRequestHeaders();
    const url = getPythonRequestURL(request);
    const requestOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
    };
    const response = await fetch(url, requestOptions);
    const res = (await response.json());
    return res;
};

export { pythonGCFCallable, pythonGCFPostCallable };
